import React, { FC } from 'react';
import { useTemplatesContext } from '@components/Contexts/TemplatesContext';
import MultiSelectionFilter from '@components/Templates/FilterPanel/MultiSelectionFilter';
import { STYLES } from '@common/types';

type Props = {};

const StylesFilter: FC<Props> = ({}) => {
  const {
    state: { filters },
  } = useTemplatesContext();

  return (
    <MultiSelectionFilter
      selectedValue={filters.styles}
      items={STYLES}
      langTokenPrefix={'marketplace.templates-page.styles-'}
      updatedQueryParam={'styles'}
      dataHook={'styles'}
      type={'styles'}
    />
  );
};

export default StylesFilter;
